import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type UnifiedProfileItemProps = { name: string; link: string };

export const UnifiedProfileItem: FC<UnifiedProfileItemProps> = ({ name, link }) => {
  const { t } = useTranslation('unifiedProfile');

  return (
    <div className='flex w-full items-center justify-between px-6 py-[26px]'>
      <p title={name} className='truncate text-sm font-medium text-primary-900 first-letter:capitalize'>
        {name}
      </p>
      <a href={link} target='_blank' className='shrink-0 text-sm font-semibold text-brand-600 first-letter:capitalize' rel='noreferrer'>
        {t('showDetails')}
      </a>
    </div>
  );
};
